export enum ModuleUserPermissions {
    module_structure_management = 'module_structure_management',
    module_display_management = 'module_display_management',
    module_content_management = 'module_content_management',
    module_event_management = 'module_event_management',
    module_grade_management = 'module_grade_management',
    module_certificate_management = 'module_certificate_management',
    course_booking_management = 'course_booking_management',
}
